import { FormControl, IconButton, InputAdornment, InputLabel, makeStyles, OutlinedInput } from "@material-ui/core"
import { Assignment, FileCopyOutlined } from "@material-ui/icons"
import React, { useRef } from "react"
import { ColumnBox, useSnackbar } from ".."

const useInputStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.readonly,
    backgroundColor: theme.palette.textinput.readonly,
    fontSize: 14,
  },
  input: {
    paddingTop: 14,
    paddingBottom: 14,
  },
}))

const useStyles = makeStyles(() => ({
  inlineCopyButton: {
    padding: 0,
    paddingLeft: 8,
    marginRight: -6,
  },
}))

const ReadOnlyTextField = ({
  id,
  label,
  variant = "outlined",
  hasCopy = false,
  multiline = false,
  fullWidth = false,
  ...rest
}) => {
  const classes = useStyles()
  const inputClasses = useInputStyles()
  const inputRef = useRef(null)
  const { showMessage } = useSnackbar()

  const handleCopy = () => {
    inputRef.current.select()
    document.execCommand("copy")
    showMessage({ message: "Copied to your clipboard", icon: <Assignment /> })
    inputRef.current.blur()
  }

  return (
    <FormControl variant="outlined" fullWidth={fullWidth}>
      {label && <InputLabel>{label}</InputLabel>}
      <OutlinedInput
        inputRef={inputRef}
        variant={variant}
        classes={inputClasses}
        multiline={multiline}
        notched
        {...rest}
        endAdornment={
          hasCopy && !multiline ? (
            <InputAdornment position="end">
              <IconButton onClick={handleCopy} className={classes.inlineCopyButton} size="small">
                <FileCopyOutlined />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      />
      {hasCopy && multiline && (
        <ColumnBox alignItems="flex-end">
          <IconButton onClick={handleCopy}>
            <FileCopyOutlined />
          </IconButton>
        </ColumnBox>
      )}
    </FormControl>
  )
}

export { ReadOnlyTextField }
